import type { AxiosError } from 'axios'

import type { HttpResponse } from '@/shared/_core/infra/http/protocols'
import type { ServiceResponse } from '@/types/services'

const responseHandler = <T, TParsedData = unknown>(
  response: HttpResponse<T>,
  parseData: (data: T) => TParsedData,
): ServiceResponse<TParsedData | undefined> => {
  return {
    data: parseData(response.data),
    status: response?.statusCode || 200,
    ok: true,
  }
}

const errorHandler = <T, D>(
  err: AxiosError<D> | Error,
  parseError?: (err: Error | AxiosError<D>) => D,
): ServiceResponse<T | undefined> => {
  const errorData = JSON.stringify(
    parseError ? parseError(err) : (err as AxiosError<D>).response?.data,
  )
  return {
    data: undefined,
    status: (err as AxiosError<D>).response?.status || 500,
    ok: false,
    error: errorData,
  }
}

export { responseHandler, errorHandler }
